import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function MumbaiToGoaCabBooking() {



    const cardData = {





keyword: "Mumbai to Goa Cab Booking",

headingDescription: "Shreesha Tours & Travels provides easy and reliable Mumbai to Goa Cab Booking services for tourists, families, corporate travelers, couples, and groups planning a comfortable journey to Goa. We offer a variety of chauffeur-driven vehicles including Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium cars for one-way, round-trip, and customized Goa travel plans. With experienced drivers, clean vehicles, flexible pickup locations, transparent pricing, and 24/7 customer assistance, we ensure a smooth and hassle-free travel experience from Mumbai to Goa. Whether you are visiting Goa for beaches, sightseeing, business, or vacations, Shreesha Tours & Travels provides convenient cab booking options with complete safety and comfort.",

topPlaces: [
  {
    title: "Betul Beach Goa",
    description: "Betul Beach is a peaceful coastal destination in South Goa known for its scenic beauty, fishing village atmosphere, clean shoreline, and relaxing surroundings. It is an ideal place for travelers who want to explore a quieter side of Goa away from crowded tourist beaches. Visitors can enjoy beautiful sunsets, local seafood, and a calm seaside experience."
  },
  {
    title: "Fort Aguada Goa",
    description: "Fort Aguada is a historic Portuguese fort located near the Arabian Sea, famous for its lighthouse, old architecture, and panoramic coastal views. The fort is one of Goa's most visited heritage attractions and offers excellent photography opportunities for tourists exploring North Goa."
  },
  {
    title: "Mobor Beach Goa",
    description: "Mobor Beach is a beautiful South Goa destination known for luxury resorts, water activities, river views, and peaceful beach surroundings. It is suitable for families and couples looking for a premium holiday experience with comfortable stays and relaxing coastal activities."
  },
  {
    title: "Ponda Goa Temples",
    description: "Ponda is known as Goa's cultural and spiritual center, featuring famous temples like Shri Mangueshi Temple and Shri Shantadurga Temple. Travelers interested in Goan traditions, architecture, and spirituality often include Ponda during their sightseeing journey."
  },
  {
    title: "Kakolem Beach Goa",
    description: "Kakolem Beach, also known as Tiger Beach, is a hidden gem in South Goa famous for its untouched beauty, cliffs, and peaceful atmosphere. The beach offers a unique experience for adventure seekers and nature lovers looking for less explored destinations."
  },
  {
    title: "Mandrem Beach Goa",
    description: "Mandrem Beach is a peaceful North Goa beach known for its soft sand, relaxing environment, beach huts, and beautiful sunsets. It is popular among travelers who prefer a calm holiday experience with natural surroundings and fewer crowds."
  },
  {
    title: "Fontainhas Goa",
    description: "Fontainhas is Goa's heritage Latin Quarter featuring colorful Portuguese houses, traditional streets, art galleries, and charming cafés. It offers visitors a chance to experience Goa's colonial history, culture, and unique architectural beauty."
  },
  {
    title: "Cotigao Wildlife Sanctuary Goa",
    description: "Cotigao Wildlife Sanctuary is a nature destination in South Goa known for dense forests, wildlife, tree-top viewpoints, and peaceful natural surroundings. It is a great attraction for travelers interested in eco-tourism, photography, and exploring Goa beyond beaches."
  },
  {
    title: "Palolem Beach Goa",
    description: "Palolem Beach is a popular South Goa destination famous for its scenic coastline, calm waters, beach cottages, dolphin trips, and relaxing atmosphere. It is a preferred choice for couples, families, and travelers looking for a beautiful beach holiday."
  },
  {
    title: "Old Goa Heritage Area",
    description: "Old Goa is a historic destination known for magnificent churches, Portuguese architecture, museums, and heritage monuments. Visitors can explore the rich cultural history of Goa while experiencing famous attractions like ancient churches and traditional landmarks."
  }
],


"services": [
  {
    "name": "Mumbai to Goa Cab Booking Price",
    "description": "Get affordable Mumbai to Goa Cab Booking Price with transparent fares, reliable service, and multiple vehicle options for a comfortable journey. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and luxury cabs with professional chauffeurs. Enjoy easy booking, doorstep pickup, flexible travel schedules, and safe highway transportation for family trips, corporate travel, holidays, and one-way or round-trip journeys."
  },
  {
    "name": "Mumbai to Goa Cab Charges",
    "description": "Check Mumbai to Goa Cab Charges with clear pricing, no hidden fees, and comfortable chauffeur-driven vehicles. Our cab services provide affordable travel solutions with different car categories, experienced drivers, clean AC vehicles, and flexible packages suitable for vacations, business trips, airport transfers, and long-distance travel."
  },
  {
    "name": "Mumbai to Goa Cab Rates",
    "description": "Compare Mumbai to Goa Cab Rates and select the best vehicle according to your travel needs and budget. Get competitive pricing for Sedan, SUV, Innova, Innova Crysta, and premium cabs with professional drivers, comfortable seating, luggage space, and reliable service throughout the journey."
  },
  {
    "name": "Mumbai to Goa Cab Service",
    "description": "Book Mumbai to Goa Cab Service for safe, comfortable, and convenient travel with experienced chauffeurs and well-maintained AC vehicles. Whether travelling for a holiday, family vacation, corporate requirement, or sightseeing trip, enjoy smooth transportation with flexible one-way and round-trip cab options."
  },
  {
    "name": "Mumbai to Goa Cab Service Fare",
    "description": "Get Mumbai to Goa Cab Service Fare with affordable packages designed for comfortable long-distance travel. Choose from multiple vehicle options with transparent pricing, professional drivers, timely pickup, and reliable travel support for personal and business journeys."
  },
  {
    "name": "Mumbai to Goa Car Hire",
    "description": "Hire Mumbai to Goa Car Hire services for a comfortable road trip with private vehicles and professional chauffeurs. Select premium and budget-friendly cars including Sedan, Ertiga, Innova, Innova Crysta, and Kia Carens for family tours, corporate travel, and vacation trips."
  },
  {
    "name": "Mumbai to Goa Car Booking",
    "description": "Complete Mumbai to Goa Car Booking online with easy reservations, quick confirmation, and multiple vehicle choices. Enjoy private cab travel with experienced drivers, clean interiors, flexible pickup locations, and comfortable rides from Mumbai to Goa."
  },
  {
    "name": "Mumbai to Goa One Way Cab",
    "description": "Book Mumbai to Goa One Way Cab for affordable drop taxi services without return charges. Enjoy direct travel with professional chauffeurs, comfortable AC vehicles, flexible pickup timings, and hassle-free transportation for your Goa journey."
  },
  {
    "name": "Mumbai to Goa Taxi Price",
    "description": "Know Mumbai to Goa Taxi Price and choose reliable taxi options according to your budget and comfort requirements. Get affordable fares with Sedan, SUV, Innova, and premium taxi options supported by experienced drivers."
  },
  {
    "name": "Mumbai to Goa Taxi Rate",
    "description": "Get updated Mumbai to Goa Taxi Rate with transparent pricing and comfortable travel solutions. Select your preferred vehicle category and enjoy safe highway travel with professional chauffeurs, clean vehicles, and reliable cab service."
  },
  {
    "name": "Mumbai to Goa One Way Taxi",
    "description": "Reserve Mumbai to Goa One Way Taxi for convenient point-to-point travel with affordable fares and no return charges. Enjoy private transportation with comfortable seating, skilled drivers, and flexible booking options."
  },
  {
    "name": "Taxi Service from Mumbai to Goa",
    "description": "Choose Taxi Service from Mumbai to Goa for reliable long-distance transportation with experienced chauffeurs and premium AC vehicles. Perfect for tourists, families, corporate travelers, and private Goa trips."
  },
  {
    "name": "Mumbai to Goa Taxi Service",
    "description": "Book Mumbai to Goa Taxi Service for safe and comfortable travel with professional drivers and well-maintained vehicles. Enjoy smooth journeys with one-way, round-trip, holiday, and sightseeing taxi packages."
  },
  {
    "name": "Luxury Cab Mumbai to Goa",
    "description": "Travel in comfort with Luxury Cab Mumbai to Goa featuring premium vehicles, spacious interiors, and professional chauffeur service. Ideal for VIP travelers, corporate journeys, family vacations, and luxury Goa tours."
  },
  {
    "name": "Best Mumbai to Goa Cab Service",
    "description": "Choose the Best Mumbai to Goa Cab Service for reliable travel with experienced drivers, clean AC vehicles, and affordable pricing. Enjoy premium comfort, doorstep pickup, flexible booking, and smooth highway travel."
  },
  {
    "name": "Online Mumbai to Goa Cab Booking",
    "description": "Book Online Mumbai to Goa Cab Booking with instant confirmation, easy reservations, and multiple vehicle options. Enjoy convenient digital booking, transparent fares, professional chauffeurs, and comfortable travel anytime."
  },
  {
    "name": "Mumbai to Goa Chauffeur Driven Cab",
    "description": "Hire Mumbai to Goa Chauffeur Driven Cab for stress-free travel with trained drivers and premium vehicles. Relax during your journey with safe driving, personalized service, and comfortable long-distance transportation."
  },
  {
    "name": "Mumbai to Goa Kia Carens Cab",
    "description": "Book Mumbai to Goa Kia Carens Cab for premium family travel with spacious seating, modern interiors, and comfortable rides. Perfect for groups, families, and travelers carrying extra luggage."
  },
  {
    "name": "Mumbai to Goa Airport Drop Cab",
    "description": "Reserve Mumbai to Goa Airport Drop Cab for timely airport transfers with professional drivers and reliable vehicles. Enjoy convenient pickup, luggage assistance, and comfortable airport transportation."
  },
  {
    "name": "Mumbai to Goa Holiday Cab Package",
    "description": "Choose Mumbai to Goa Holiday Cab Package for customized vacation travel with comfortable vehicles and flexible schedules. Explore Goa beaches, resorts, sightseeing locations, and tourist attractions with professional cab services."
  },
  {
    "name": "Mumbai to Goa Tour Package by Cab",
    "description": "Book Mumbai to Goa Tour Package by Cab for complete holiday transportation with sightseeing support and comfortable private vehicles. Enjoy customized travel plans covering beaches, attractions, resorts, and popular Goa destinations."
  },
  {
    "name": "Mumbai to Goa Family Trip Cab",
    "description": "Reserve Mumbai to Goa Family Trip Cab for safe and comfortable journeys with spacious vehicles and experienced chauffeurs. Travel conveniently with family-friendly cars designed for long-distance trips."
  },
  {
    "name": "Mumbai to Goa Tourist Taxi",
    "description": "Hire Mumbai to Goa Tourist Taxi for sightseeing and vacation travel with reliable drivers and comfortable vehicles. Explore Goa attractions with flexible travel plans and private transportation."
  },
  {
    "name": "Mumbai to Goa Holiday Cab",
    "description": "Book Mumbai to Goa Holiday Cab for relaxing vacation travel with affordable packages and premium vehicles. Enjoy comfortable journeys for weekend trips, family holidays, and sightseeing tours."
  },
  {
    "name": "Mumbai to Goa Beach Tour Cab",
    "description": "Choose Mumbai to Goa Beach Tour Cab for convenient beach travel with private vehicles and professional drivers. Visit popular Goa beaches with flexible sightseeing schedules."
  },
  {
    "name": "Mumbai to Goa Vacation Taxi",
    "description": "Reserve Mumbai to Goa Vacation Taxi for comfortable holiday transportation with reliable service and premium vehicles. Perfect for couples, families, and groups planning Goa vacations."
  },
  {
    "name": "Mumbai to Goa Weekend Trip Cab",
    "description": "Book Mumbai to Goa Weekend Trip Cab for quick and comfortable weekend travel. Enjoy safe rides, experienced chauffeurs, and convenient travel options for short vacations."
  },
  {
    "name": "Mumbai to Goa Travel Package",
    "description": "Choose Mumbai to Goa Travel Package for customized cab tours with comfortable vehicles and flexible itineraries. Enjoy sightseeing, hotel transfers, and private travel arrangements."
  },
  {
    "name": "Mumbai to Goa Sightseeing Cab",
    "description": "Hire Mumbai to Goa Sightseeing Cab for exploring beaches, markets, churches, forts, and tourist attractions. Travel comfortably with experienced drivers and private vehicles."
  },
  {
    "name": "Mumbai to North Goa Cab",
    "description": "Book Mumbai to North Goa Cab for direct travel to popular destinations like Calangute, Baga, Candolim, and Anjuna. Enjoy reliable transportation with comfortable AC vehicles."
  },
  {
    "name": "Mumbai to South Goa Cab",
    "description": "Reserve Mumbai to South Goa Cab for peaceful travel to beaches, resorts, and scenic locations. Get comfortable rides with professional drivers and flexible booking options."
  },
  {
    "name": "Mumbai to Calangute Cab",
    "description": "Choose Mumbai to Calangute Cab for convenient travel to one of Goa's famous beach destinations. Enjoy private transportation with comfortable vehicles and experienced chauffeurs."
  },
  {
    "name": "Mumbai to Baga Beach Cab",
    "description": "Book Mumbai to Baga Beach Cab for easy and comfortable travel to the famous Goa beach destination. Enjoy safe rides with clean vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Candolim Cab",
    "description": "Reserve Mumbai to Candolim Cab for reliable transportation to Goa's popular tourist area. Travel comfortably with private cabs and flexible travel schedules."
  },
  {
    "name": "Mumbai to Panaji Cab",
    "description": "Hire Mumbai to Panaji Cab for convenient travel to Goa's capital city. Enjoy smooth journeys with experienced chauffeurs and premium AC vehicles."
  },
  {
    "name": "Mumbai to Vagator Cab",
    "description": "Book Mumbai to Vagator Cab for comfortable travel to Goa's scenic beach destination. Enjoy reliable service with professional drivers and spacious vehicles."
  },
  {
    "name": "Mumbai to Anjuna Cab",
    "description": "Choose Mumbai to Anjuna Cab for private transportation to the famous Goa tourist location. Travel safely with experienced chauffeurs and comfortable cars."
  },
  {
    "name": "Mumbai to Goa Resort Transfer Cab",
    "description": "Reserve Mumbai to Goa Resort Transfer Cab for direct hotel and resort transportation. Enjoy timely pickup, luggage assistance, and comfortable travel from Mumbai to Goa resorts."
  },
  {
    "name": "Mumbai to Goa Beach Taxi",
    "description": "Book Mumbai to Goa Beach Taxi for convenient beach transfers and sightseeing travel. Enjoy private cab services with flexible routes and professional drivers."
  },
  {
    "name": "Mumbai to Goa Innova Crysta Cab",
    "description": "Hire Mumbai to Goa Innova Crysta Cab for premium comfort with spacious interiors and luxury travel experience. Ideal for families, groups, and long-distance journeys."
  },
  {
    "name": "Mumbai to Goa Ertiga Cab",
    "description": "Choose Mumbai to Goa Ertiga Cab for affordable family travel with comfortable seating and reliable chauffeur service. Perfect for groups looking for economical and spacious transportation."
  }
],
"tableData": [
  ["Mumbai to Goa Cab Booking Price", "Mumbai to Goa Cab Charges"],
  ["Mumbai to Goa Cab Rates", "Mumbai to Goa Cab Service"],
  ["Mumbai to Goa Cab Service Fare", "Mumbai to Goa Car Hire"],
  ["Mumbai to Goa Car Booking", "Mumbai to Goa One Way Cab"],
  ["Mumbai to Goa Taxi Price", "Mumbai to Goa Taxi Rate"],
  ["Mumbai to Goa One Way Taxi", "Taxi Service from Mumbai to Goa"],
  ["Mumbai to Goa Taxi Service", "Luxury Cab Mumbai to Goa"],
  ["Best Mumbai to Goa Cab Service", "Online Mumbai to Goa Cab Booking"],
  ["Mumbai to Goa Chauffeur Driven Cab", "Mumbai to Goa Kia Carens Cab"],
  ["Mumbai to Goa Airport Drop Cab", "Mumbai to Goa Holiday Cab Package"],
  ["Mumbai to Goa Tour Package by Cab", "Mumbai to Goa Family Trip Cab"],
  ["Mumbai to Goa Tourist Taxi", "Mumbai to Goa Holiday Cab"],
  ["Mumbai to Goa Beach Tour Cab", "Mumbai to Goa Vacation Taxi"],
  ["Mumbai to Goa Weekend Trip Cab", "Mumbai to Goa Travel Package"],
  ["Mumbai to Goa Sightseeing Cab", "Mumbai to North Goa Cab"],
  ["Mumbai to South Goa Cab", "Mumbai to Calangute Cab"],
  ["Mumbai to Baga Beach Cab", "Mumbai to Candolim Cab"],
  ["Mumbai to Panaji Cab", "Mumbai to Vagator Cab"],
  ["Mumbai to Anjuna Cab", "Mumbai to Goa Resort Transfer Cab"],
  ["Mumbai to Goa Beach Taxi", "Mumbai to Goa Innova Crysta Cab"],
  ["Mumbai to Goa Ertiga Cab", ""]
],



whychoose: [
  {
    WhyChooseheading: "Easy Mumbai to Goa Cab Booking Service",
    WhyChoosedescription: "Shreesha Travels makes Mumbai to Goa cab booking simple and convenient with private chauffeur-driven cars, flexible travel options, and comfortable vehicles for families, tourists, business travellers, and groups."
  },
  {
    WhyChooseheading: "Quick Reservation for Mumbai Goa Travel",
    WhyChoosedescription: "Plan your Goa journey in advance with hassle-free cab booking from Mumbai. Get doorstep pickup, direct destination drop, and smooth coordination for your complete travel schedule."
  },
  {
    WhyChooseheading: "Multiple Cab Categories Available",
    WhyChoosedescription: "Choose the right vehicle according to your travel needs from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars."
  },
  {
    WhyChooseheading: "Private Cab for Holiday & Business Trips",
    WhyChoosedescription: "Mumbai to Goa private taxis are suitable for vacations, honeymoon journeys, corporate visits, family tours, group travel, and special occasions requiring comfortable transportation."
  },
  {
    WhyChooseheading: "One Way and Round Trip Booking Facility",
    WhyChoosedescription: "Select a one-way cab for direct travel to Goa or choose a round-trip package with return arrangements, flexible timings, sightseeing stops, and customized travel plans."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai Goa Highway",
    WhyChoosedescription: "Skilled chauffeurs with highway route knowledge provide safe driving, smooth navigation, timely service, and a comfortable journey throughout the Mumbai to Goa route."
  },
  {
    WhyChooseheading: "Reliable Fleet for Long Distance Journeys",
    WhyChoosedescription: "Every vehicle is maintained with regular servicing, cleaning, air conditioning, and safety checks to provide passengers with a comfortable and secure travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Goa Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, professional chauffeur service, quick booking support, and reliable cab solutions for your Mumbai to Goa travel requirements."
  }
]

};

const faqData = [
  {
    question: "How can I book a Mumbai to Goa cab?",
    answer: "You can book a Mumbai to Goa cab by sharing your travel date, pickup location, passenger details, destination in Goa, and preferred vehicle type."
  },
  {
    question: "Can I book Mumbai to Goa cab online?",
    answer: "Yes, online cab booking assistance is available for convenient reservation and travel planning."
  },
  {
    question: "Do you provide one-way Mumbai to Goa cab booking?",
    answer: "Yes, one-way taxi bookings are available for travellers who need direct transportation to Goa."
  },
  {
    question: "Can I reserve a round-trip cab from Mumbai to Goa?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Which vehicles can I book for Mumbai to Goa?",
    answer: "Available options include Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a Mumbai Airport to Goa cab?",
    answer: "Yes, airport pickup services are available from Mumbai Airport for direct travel to Goa."
  },
  {
    question: "Is Mumbai to Goa cab booking suitable for family groups?",
    answer: "Yes, spacious vehicles are available for families, senior citizens, couples, and large groups."
  },
  {
    question: "How much does Mumbai to Goa cab booking cost?",
    answer: "The fare depends on vehicle category, travel distance, route, toll charges, parking fees, trip type, and additional requirements."
  },
  {
    question: "Can I customize my Mumbai to Goa cab trip?",
    answer: "Yes, you can customize pickup points, travel timing, sightseeing stops, and vehicle selection according to your requirements."
  },
  {
    question: "How can I confirm Mumbai to Goa Cab Booking with Shreesha Travels?",
    answer: "Share your journey details with our team to receive vehicle availability, pricing details, and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Patil",
    feedback: "The Mumbai to Goa cab booking process was very smooth. The vehicle arrived on time, the driver was experienced, and the complete journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Sharma",
    feedback: "A convenient way to plan a Goa trip. The cab was clean, communication was excellent, and the travel experience was enjoyable.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cab Booking",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-goa-cab-booking.webp",
  "description":
    "Book Mumbai to Goa Cab Booking with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Goa vacations, family trips, luxury travel, one-way journeys, round trips, and long-distance travel from Mumbai to Goa with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-goa-cab-booking"
  }
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Goa Cab Booking | Goa Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Goa Cab Booking with Shreesha Travels for safe and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Goa trips, luxury travel, one-way cab, round trips, family vacations, and 24x7 cab booking from Mumbai to Goa."
  />

  <meta
    name="keywords"
    content="Mumbai to Goa Cab Booking Price, Mumbai to Goa Cab Charges, Mumbai to Goa Cab Rates, Mumbai to Goa Cab Service, Mumbai to Goa Cab Service Fare, Mumbai to Goa Car Hire, Mumbai to Goa Car Booking, Mumbai to Goa One Way Cab, Mumbai to Goa Taxi Price, Mumbai to Goa Taxi Rate, Mumbai to Goa One Way Taxi, Taxi Service from Mumbai to Goa, Mumbai to Goa Taxi Service, Luxury Cab Mumbai to Goa, Mumbai Goa Premium Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/117.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default MumbaiToGoaCabBooking;